import React from "react";

import { Link } from "components/Link";
import { RichTextModule } from "components/RichTextModule";

import leadMediaStyles from "./leadMedia.module.scss";
import styles from "./responsiveImageModule.module.scss";

const Citation: React.FC<{ credit: string; creditLink: string }> = (props) => {
    const { credit, creditLink } = props;

    return credit ? (
        <cite>
            {creditLink ? (
                <Link href={creditLink} target="_blank">
                    {credit}
                </Link>
            ) : (
                credit
            )}
        </cite>
    ) : null;
};

const Caption: React.FC<{ caption: string; credit: string; creditLink: string }> = (props) => {
    const { caption, credit, creditLink } = props;
    const Cite = <Citation {...{ credit, creditLink }} />;
    const Cap = <RichTextModule {...{ type: undefined, className: undefined, richText: caption }} />;

    return Cite || caption ? (
        <figcaption className={`${leadMediaStyles.caption} ${styles.caption}`}>
            {Cap}
            {credit && caption ? " | " : ""}
            {Cite}
        </figcaption>
    ) : null;
};

export { Caption };
